import * as React from 'react';
import { getRateLimitSecondsRemaining } from './upload-utils';

export const useRateLimitCountdown = (isRateLimited: boolean, resumeAt?: number): number | undefined => {
    const [secondsRemaining, setSecondsRemaining] = React.useState<number | undefined>();

    React.useEffect(() => {
        if (!isRateLimited || resumeAt === undefined) {
            setSecondsRemaining(undefined);
            return undefined;
        }

        const updateCountdown = (): void => {
            setSecondsRemaining(getRateLimitSecondsRemaining(resumeAt));
        };

        updateCountdown();
        const intervalId = window.setInterval(updateCountdown, 1000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [isRateLimited, resumeAt]);

    return secondsRemaining;
};
